import EmployeeService from "../../../../users-management/services/EmployeeService";

export function getCurrentCompanyRequest() {
  return EmployeeService.getCurrentCompany();
}
